import {PasswordDefinitions} from "@/Enums/PasswordDefinitions";

class PasswordValidationService {

    static checkIsValidLength(password) {
        return password.length >= PasswordDefinitions.MIN_LENGTH;
    }

    static checkUppercase(str) {
        return str.toLowerCase() !== str;
    }

    static checkLowercase(str) {
        return str.toUpperCase() !== str;
    }

    static checkContainsNumber(str) {
        return /\d/.test(str);
    }

    static checkHasSpecialChar(str) {
        let specialCharacters = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;

        return specialCharacters.test(str);
    }

    static checkIfPasswordsMatch(name, value, data) {
        if (!value) {
            return false;
        } else if (name === "password") {
            return value === data.password_confirmation;
        } else if (name === "password_confirmation") {
            return value === data.password;
        }
    }
}
export default PasswordValidationService;
